import React from 'react';
import classnames from 'classnames';

import { Input, version2 } from 'ui-components/components/input';
import { Text, TextType } from 'ui-components/components/text';

import styles from './contact-details-section.module.less';
import { messages } from './messages';

/**
 * @param {object} props
 * @param {string} props.fieldId - The input field ID
 * @param {object} props.labelMessageDescriptor - The message descriptor for the label
 * @param {string} [props.className] - Additional CSS class name
 * @param {string} [props.inputClassName] - Input CSS class name
 * @param {boolean} [props.isOptional] - Whether the field is optional
 * @param {string} props.value - The input value
 * @param {(field: string, event: Event) => void} props.onContactDetailChange - Handler for input changes
 * @param {string} [props.type] - The input type (e.g., 'email', 'tel')
 * @returns {JSX.Element} The labeled input component
 */
export const ContactDetailsInputField = ({
  fieldId,
  labelMessageDescriptor,
  className,
  inputClassName,
  isOptional = false,
  value,
  onContactDetailChange,
  type,
}) => {
  return (
    <div className={classnames(styles.field, className)}>
      <div className={styles['label-wrapper']}>
        <Text htmlFor={fieldId} textType={TextType.Label} value={labelMessageDescriptor} />
        {isOptional ? <Text className={styles['caption-text']} textType={TextType.Caption} value={messages.optional} /> : null}
      </div>
      <Input
        className={inputClassName}
        id={fieldId}
        onChange={(event) => onContactDetailChange(fieldId, event)}
        type={type}
        value={value}
        version={version2}
      />
    </div>
  );
};
